import { render, staticRenderFns } from "./TypeControl.vue?vue&type=template&id=6673adc5&scoped=true"
import script from "./TypeControl.vue?vue&type=script&lang=js"
export * from "./TypeControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673adc5",
  null
  
)

export default component.exports